import { entries } from '#helpers/otherHelpers.ts';
import { type MovieFormikValues, type TvFormikValues } from '../types.ts';

export const filterOutEmptyValues = (values: MovieFormikValues | TvFormikValues) => {
  const filtered: Partial<MovieFormikValues | TvFormikValues> = {};

  for (const [key, value] of entries(values)) {
    if (
      (Array.isArray(value) && value.length > 0) ||
      // Technically value can be undefined
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (!Array.isArray(value) && value !== undefined && value !== false)
    ) {
      // @ts-expect-error The key/value pair
      filtered[key] = value;
    }
  }

  return filtered;
};
